import React, {Component} from "react"
import {Link, withRouter} from "react-router-dom"
import {Form, Card, FormField, FormInput, ButtonGroup} from "elemental-react16"
import {Button} from "semantic-ui-react"
import queryString from "qs"
import shop from "shop/shop"

@withRouter
class ResetPasswordPage extends Component {

  state = {
    response:  false,
    email:     "",
    password0: "",
    password1: ""
  }

  componentDidMount() {
    let query    = queryString.parse( this.props.location.search, { ignoreQueryPrefix: true } )
    const key    = query.key
    const subkey = query.subkey

    if ( key && subkey ) {
      this.setState( { key, subkey } )
      console.log( `key`, key )
    }
  }

  setEmail = (e) => {
    this.setState( { email: e.target.value } )
  }

  resetPassword = (e) => {
    const ERRORS_PW = {
      TO_SHORT:  1,
      NOT_EQUAL: 2
    }

    let query    = queryString.parse( this.props.location.search, { ignoreQueryPrefix: true } )
    const key    = query.key
    const subkey = query.subkey

    const password            = this.state.password0
    const password_validation = this.state.password1

    let flag = false

    if ( password !== password_validation ) flag = ERRORS_PW.NOT_EQUAL
    if ( password && password.length < 4 ) flag = ERRORS_PW.TO_SHORT

    if ( flag === ERRORS_PW.TO_SHORT ) {
      window.swal( "Passwort zu kurz", "Bitte nutzen Sie ein längeres Passwort", "error" )
      return
    }

    if ( flag === ERRORS_PW.NOT_EQUAL ) {
      window.swal( "Passwörter stimmen nicht überein", "Sie haben verschiedene Passwörter eingegeben", "error" )
      return
    }

    console.info( "resetPassword::resetPassword", key )
    // jQuery.ajax({ url: '/shop/rest/security/resetpass',data: JSON.stringify({"subkey":1,"key":"25576688485240761757","password":"neuesPass"}), type: 'POST', processData: false, contentType: false });
    e.preventDefault()

    shop.resetPassword( { key, password, subkey } )
      .then( () => {
        onSuccess( this.props.history )
      } )
      .catch( onError )

    return false
  }

  requestPassword = (e) => {
    const { email } = this.state

    shop.requestPassword( email )
      .then( response => {
        if ( response ) {
          window.swal( translate("E-Mail versendet"), translate("PW_RESET_SUCCESS", {email}),
            "success" )
          this.setState( { response } )
        }
      } )
      .catch( e => {
        console.error( `PW RESET ERROR: ${e}` )
        // window.swal( "Fehler", `Die von Ihnen eingegebene Emailadresse ${email} wurde nicht gefunden.  \n \n` +
        //   "",
        //   "error" )
        window.swal( "Fehler", translate("PW_RESET_ERROR", {email}) , "error" )
      } )

    e.preventDefault()
    return false
  }

  render() {
    const { email } = this.state
    let query       = queryString.parse( this.props.location.search, { ignoreQueryPrefix: true } )
    const key       = query.key
    const subkey    = query.subkey
    return (
      <div>
        <div style={{ borderTop: "2px solid rgb(201, 201, 201)"}} className=" pt3 resetPWBackground ">
          {/*REQUEST RESET*/}
          {!key && !subkey && <div className="overflow-hidden resetPWBackground">
            {/*<h3>{translate("Passwort zurücksetzen")}</h3> */}
            <Form onSubmit={this.requestPassword}>
              <FormField label={<label className="fw7">{translate("Ihre bei uns registrierte E-Mail Adresse:")}</label>} htmlFor="basic-form-input-email">
                <FormInput value={email}
                           onChange={this.setEmail}
                           type="email" required placeholder={translate("E-Mail")}
                           name="basic-form-input-email"/>
              </FormField>
              <div className="">
                <Button className="tc mb3" primary style={{width: "100%", borderRadius: "35px", height: "50px"}} submit><p className="fw7">{translate("Passwort zurücksetzen")}</p></Button>
                {/*<Link to="/login"> <Button type="default">{translate("Zurück zur Anmeldung")}</Button></Link> */}
              </div>
            </Form>
          </div>}

          {/*RESET PASSWORD */}
          {key && subkey && <Card className="overflow-hidden">
            <h3>{translate("Passwort wählen")}</h3>
            <Form onSubmit={(e) => {
              e.preventDefault()
              return false
            }}>
              <FormField label={translate("Ihr neues Passwort")} htmlFor="basic-form-input-email">
                <FormInput value={this.state.password0}
                           onChange={(e) => { this.setState( { password0: e.target.value } )}}
                           type="password" required
                           name="basic-form-input-email"/>
              </FormField>

              <FormField label={translate("Passwort wiederholen")} htmlFor="basic-form-input-email">
                <FormInput value={this.state.password1}
                           onChange={(e) => { this.setState( { password1: e.target.value } )}}
                           type="password" required
                           name="basic-form-input-email"/>
              </FormField>

              <div className="">
                <Button submit onClick={this.resetPassword} className="fr mb3" type="primary">{translate("Passwort setzen")}</Button>
              </div>
            </Form>
          </Card>}
        </div>
      </div>
    )
  }
}

function onSuccess(history) {
  history.push( "/login" )
  window.swal( translate("Reset  erfolgreich"), translate("Sie können sich nun mit Ihrem neuen Passwort anmelden."), "success" )
}

function onError(err) {
  console.warn( `error`, err )
  window.swal( translate("Error"), translate("Es trat leider ein unbekannter Fehler auf"), "error" )
}

export default ResetPasswordPage



// WEBPACK FOOTER //
// ./src/theme/trendimport.test/pages/ResetPasswordPage.js